import get from 'lodash.get';

const getComponent = (rootState) => get(rootState, 'ui.customUI.active', {});

export default getComponent;
